import React from 'react'

function Privacy() {
  return (
    <div>
      <h2
        style={{
          marginBottom: 20,
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 20,
        }}
      >
        Privacy Policy
      </h2>
      <ul style={{ marginLeft: 20, marginRight: 20 }}>
        <li>
        Thank you for visiting Parchun King. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
        </li>
        <li>
        We may collect the following types of information when you use our website:
        </li>
        <ol>
          <li>
          <b>Personal Information:</b> When you voluntarily provide it to us, such as when you fill out a contact form or subscribe to our newsletter. This may include your name, email address, and other contact details.
          </li>
          <li>
          <b>Usage Information:</b> We collect information about how you interact with our website, such as your IP address, browser type, and pages visited. This helps us improve our website and provide a better user experience.
          </li>
        </ol>
        <li>
        How We Use Your Information
        </li>
        <ol>
          <li>To provide and maintain our website.</li>
          <li>To send you newsletters, updates, or marketing communications.</li>
          <li>To respond to your inquiries or provide customer support.</li>
          <li>To analyze and improve our website's performance and functionality.</li>
        </ol>
        <li>
        Disclosure of Your Information
        </li>
        <ol>
          <li>We do not sell, trade, or otherwise transfer your personally identifiable information to third parties without your consent. However, we may share your information with trusted third parties who assist us in operating our website or conducting our business.</li>
        </ol>
        <li>Your Choices</li>
        <ol>
          <li>You can choose not to provide personal information, but this may limit your ability to use certain features of our website.</li>
        </ol>
        <li>Security</li>
        <ol>
          <li>We take reasonable measures to protect your information from unauthorized access, use, or disclosure.</li>
        </ol>
        <li>Changes to This Privacy Policy</li>
        <ol>
          <li>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</li>
        </ol>
      </ul>
      <div
        style={{
          textAlign: "center",
          paddingTop: 7,
          paddingBottom: 7,
          backgroundColor: "lightgray",
        }}
      >
        Made with ❤️ by Sheetal Trading Company
      </div>
    </div>
  )
}

export default Privacy